var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareIntegrationsOutlook = function SvgYeswareIntegrationsOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70.849,
    height: 71.057,
    rx: 20.881,
    fill: "#fff",
    stroke: "#ECF0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.848 17.217h-23.1a1.896 1.896 0 0 0-1.886 1.886v2.144l13.02 4.032 13.854-4.032v-2.144a1.897 1.897 0 0 0-1.888-1.886Z",
    fill: "#0364B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.953 37.916c.197-.617.353-1.249.47-1.888a.897.897 0 0 0-.447-.776l-.017-.01-.006-.002-14.564-8.295a2.016 2.016 0 0 0-2.181 0L25.644 35.24l-.006.002-.018.01a.899.899 0 0 0-.447.776c.117.64.274 1.269.47 1.888L41.086 49.21l15.868-11.294Z",
    fill: "#0A2767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.673 21.247h-9.405L34.55 25.28l2.715 4.03 9.405 8.064h8.063V29.31l-8.06-8.063Z",
    fill: "#28A8EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.862 21.247h9.406v8.063h-9.406v-8.063Z",
    fill: "#0078D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.674 21.247h8.063v8.063h-8.063v-8.063Z",
    fill: "#50D9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m46.673 37.373-9.405-8.063h-9.406v8.063l9.406 8.062 14.554 2.375-5.149-10.437Z",
    fill: "#0364B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.269 29.31h9.405v8.063H37.27V29.31Z",
    fill: "#0078D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.862 37.373h9.406v8.062h-9.406v-8.062Z",
    fill: "#064A8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.674 37.373h8.063v8.062h-8.063v-8.062Z",
    fill: "#0078D4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.555 48.414 25.707 36.86l.665-1.167 14.657 8.348a.702.702 0 0 0 .565-.016c.205-.115 14.689-8.371 14.689-8.371l.666 1.166-15.394 11.595Z",
    fill: "#0A2767",
    fillOpacity: 0.498
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m56.976 36.804-.017.01-.004.002L42.39 45.11a2.013 2.013 0 0 1-1.962.123l5.072 6.8 11.09 2.414v.006c.522-.377.833-.985.833-1.632V36.026c0 .318-.17.616-.448.776v.002Z",
    fill: "#1490DF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.424 52.826v-.991L44.01 44.192l-1.619.923a2.014 2.014 0 0 1-1.962.123l5.072 6.8 11.09 2.414v.006a2.02 2.02 0 0 0 .833-1.632Z",
    fill: "#000",
    fillOpacity: 0.047
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.356 53.34 42.65 44.962l-.262.149a2.014 2.014 0 0 1-1.962.123l5.072 6.8 11.09 2.414v.006c.38-.272.65-.667.767-1.114Z",
    fill: "#000",
    fillOpacity: 0.098
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.644 36.821v-.013h-.014l-.04-.028a.878.878 0 0 1-.417-.752v16.8c0 1.104.909 2.013 2.013 2.013h28.22c.169-.002.335-.024.497-.067a.88.88 0 0 0 .242-.08.186.186 0 0 0 .08-.027c.11-.045.214-.104.31-.174l.052-.041-30.943-17.63Z",
    fill: "#28A8EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.61 47.675V25.727a1.804 1.804 0 0 0-1.79-1.79h-8.917v10.02l-2.26 1.287-.005.002-.018.01a.894.894 0 0 0-.445.774v13.442-.006H36.82a1.804 1.804 0 0 0 1.79-1.79Z",
    fill: "#000",
    fillOpacity: 0.098
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.268 49.018V27.072a1.804 1.804 0 0 0-1.79-1.79h-7.575v8.674l-2.26 1.288-.005.002-.018.01a.894.894 0 0 0-.445.774v14.784-.006h10.302a1.804 1.804 0 0 0 1.79-1.79Zm0-2.688V27.072a1.804 1.804 0 0 0-1.79-1.79h-7.575v8.674l-2.26 1.288-.005.002-.018.01a.894.894 0 0 0-.445.774v12.097-.006h10.302a1.804 1.804 0 0 0 1.79-1.79Zm-1.345 0V27.072a1.804 1.804 0 0 0-1.79-1.79h-6.23v8.674l-2.26 1.288-.005.002-.018.01a.894.894 0 0 0-.445.774v12.097-.006h8.958a1.803 1.803 0 0 0 1.79-1.79Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.215 25.28h17.916c.983 0 1.79.809 1.79 1.79v17.916c0 .983-.809 1.79-1.79 1.79H16.215c-.983 0-1.79-.809-1.79-1.79V27.07c0-.983.809-1.79 1.79-1.79Z",
    fill: "#0078D4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.62 32.627a5.617 5.617 0 0 1 2.207-2.438 6.675 6.675 0 0 1 3.506-.88 6.213 6.213 0 0 1 3.245.833 5.561 5.561 0 0 1 2.148 2.329 7.502 7.502 0 0 1 .753 3.424 7.907 7.907 0 0 1-.776 3.583 5.674 5.674 0 0 1-2.21 2.41 6.449 6.449 0 0 1-3.367.856 6.365 6.365 0 0 1-3.317-.843 5.643 5.643 0 0 1-2.173-2.331 7.337 7.337 0 0 1-.76-3.386 8.151 8.151 0 0 1 .744-3.557Zm2.352 5.72a3.652 3.652 0 0 0 1.24 1.606 3.239 3.239 0 0 0 1.94.584 3.397 3.397 0 0 0 2.07-.602c.55-.407.97-.966 1.206-1.609a6.199 6.199 0 0 0 .385-2.238 6.814 6.814 0 0 0-.364-2.265 3.592 3.592 0 0 0-1.163-1.667 3.198 3.198 0 0 0-2.052-.633 3.351 3.351 0 0 0-1.984.588 3.688 3.688 0 0 0-1.269 1.618 6.433 6.433 0 0 0-.01 4.619Z",
    fill: "#fff"
  })));
};
export default SvgYeswareIntegrationsOutlook;